// extracted by mini-css-extract-plugin
export var headerCell = "_3l-1";
export var loadingSpinnerContainer = "_3l-4";
export var rowWrapper = "_3l-3";
export var standaloneTable = "_3l-5";
export var table = "_3l-0";
export var white = "_3l-2";